import { v4 as uuidv4 } from "uuid";
import authService from "../../services/authService.js";

import apiSoapDB from "../../api/soapdb";
import { parseDateOrToday } from "../../helpers";
import { parsePaymentData } from "../../cashhelpers";

export default {
  namespaced: true,

  state: {
    startDate: new Date(),
    endDate: new Date(),
    payments: [],
  },

  getters: {
    payments(state) {
      return state.payments;
    },
    startDate(state) {
      return state.startDate;
    },
    endDate(state) {
      return state.endDate;
    },
  },

  mutations: {
    SET_PAYMENTS(state, paymentArray) {
      state.payments = paymentArray;
    },
    SET_START_DATE(state, start_date) {
      state.startDate = start_date;
    },
    SET_END_DATE(state, end_date) {
      state.endDate = end_date;
    },
  },

  actions: {
    async getPaymentsForClientID({ state, commit, dispatch, getters, rootGetters }) {
      const curUserFromAuthModule = rootGetters["auth/currentUser"];
      const dbService = rootGetters["localdb/dbService"];

      return new Promise((resolve, reject) => {
        if (!dbService) {
          reject("NO DB SERVICE DETECTED!");
          return false;
        }

        let paymentsArray = [];
        apiSoapDB
          .doGetPaymentsForClient(
            curUserFromAuthModule.clientId,
            state.startDate,
            state.endDate
            // state.paymentDates.start,
            // state.paymentDates.end
          )
          .then((paymentsResp) => {
            console.log("PAYMENT RESPONSE", paymentsResp);
            if (
              paymentsResp.soapResultSection &&
              paymentsResp.soapResultSection.item &&
              Array.isArray(paymentsResp.soapResultSection.item)
            ) {
              paymentsResp.soapResultSection.item.forEach((payment) => {
                let parsedPayment = parsePaymentData(payment);
                let instrDetail;
                //DETAIL: USE EITHER 'xfrDelvInstructID' IF EXISTS OR 'select * from TTxnCode_Details where rid = txnCodeDetailID'
                if (!parsedPayment.xfrDelvInstructID) {
                  let stmt = dbService.prepareStatementQuery(
                    `select * from TTxnCode_Details where rid = '${parsedPayment.txnCodeDetailID}'`
                  );
                  console.log(
                    "INSTR DETAIL QUERY:",
                    `select * from TTxnCode_Details where rid = '${parsedPayment.txnCodeDetailID}'`
                  );
                  stmt.step();
                  instrDetail = stmt.getAsObject();
                  console.log("INSTRUCTION DETAIL:", instrDetail);
                }

                let relevantInstructionID =
                  parsedPayment.xfrDelvInstructID ?? instrDetail.instructionsID;
                console.log("RELEVANT INSTRUCTION ID:", relevantInstructionID);

                //DETAIL: . . . THAT WE THEN USE TO QUERY 'select * from TInstructions where shortname = result_from_previous_select'
                let stmtInstruction = dbService.prepareStatementQuery(
                  `select * from TInstructions where rid = '${relevantInstructionID}'`
                );
                console.log(
                  "INSTR OBJ QUERY",
                  `select * from TInstructions where rid = '${relevantInstructionID}'`
                );
                stmtInstruction.step();
                let instructionObject = stmtInstruction.getAsObject();
                console.log("INSTRUCTION OBJECT:", instructionObject);

                parsedPayment.beneficiary = instructionObject.BName1;

                console.log("UPDATED PARSED PAYMENT:", parsedPayment);
                paymentsArray.push(parsedPayment);
              });

              console.log("RESOLVING PAYMENTS");
            }

            commit("SET_PAYMENTS", paymentsArray);
            resolve(paymentsArray);
          })
          .catch((err) => {
            console.log("REJECTING PAYMENTS");
            reject(err);
          });
      });
    },

    async releasePayment({ state, commit, dispatch, getters, rootGetters }, rid) {
      return new Promise((resolve, reject) => {
        let curUser = authService.getCurrentUser();
        let curPayment = state.payments.find((pmt) => pmt.rid == rid);

        //FAIL IF NO USER OR NO USER PERMISSIONS
        if (!curPayment) {
          reject("NO PAYMENT WITH THAT ID!");
          return false;
        }

        //FAIL IF NO USER OR NO USER PERMISSIONS
        if (!curUser || !curUser.permissions) {
          reject("NO USER PERMISSIONS!");
          return false;
        }

        if (!curUser.permissions.userMayReleaseEFT) {
          reject("INSUFFICIENT PERMISSIONS! LEVEL 1 REQUIRED!");
          return false;
        }

        if (curPayment.wtr_status != "PENDING") {
          reject("The Cash Flow EFT status must be PENDING before it can be RELEASED !");
          return false;
        }

        apiSoapDB
          .doReleasePayment(curPayment.rid, curUser.userName)
          .then((resp) => {
            console.log("RELEASE PAYMENT SUCCESS:", resp);
            resolve(resp);
          })
          .catch((err) => {
            console.log("RELEASE PAYMENT ERROR:", err);
            reject(err);
          });
      });
    },
    async approvePayment({ state, commit, dispatch, getters, rootGetters }, rid) {
      return new Promise((resolve, reject) => {
        let curUser = authService.getCurrentUser();
        let curPayment = state.payments.find((pmt) => pmt.rid == rid);

        //FAIL IF NO USER OR NO USER PERMISSIONS
        if (!curPayment) {
          reject("NO PAYMENT WITH THAT ID!");
          return false;
        }

        //FAIL IF NO USER OR NO USER PERMISSIONS
        if (!curUser || !curUser.permissions) {
          reject("NO USER PERMISSIONS!");
          return false;
        }

        //FOLLOWING MODELLED DIRECTLY AFTER THE DESKTOP APPLICATION
        if (!curUser.permissions.requiresGroupApproval) {
          if (curUser.permissions.requiresSecondApproval) {
            if (!curUser.permissions.userMayApproveEFT) {
              reject("INSUFFICIENT PERMISSIONS!");
              return false;
            }
          } else {
            if (!curUser.permissions.userMayReleaseEFT) {
              reject("INSUFFICIENT PERMISSIONS!");
              return false;
            }
          }
        }
      });
    },

    async revokePaymentApproval({ state, commit, dispatch, getters, rootGetters }, rid) {},
  },
};
